var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sound 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5836 16.4134C10.4602 16.4134 10.3394 16.3526 10.2674 16.2412C8.61332 13.665 8.61332 10.3357 10.2674 7.7595C10.3796 7.5855 10.6109 7.53412 10.7857 7.64662C10.9601 7.75837 11.0107 7.9905 10.8989 8.16487C9.4027 10.4947 9.4027 13.506 10.8989 15.8359C11.0107 16.0102 10.9601 16.242 10.7857 16.3541C10.7231 16.3939 10.6526 16.4134 10.5836 16.4134Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.58577 18.5982C6.4624 18.5982 6.34165 18.5374 6.26965 18.4261C3.76315 14.5223 3.76315 9.47782 6.26965 5.57444C6.3814 5.40044 6.61352 5.34907 6.7879 5.46157C6.96227 5.57332 7.0129 5.80544 6.90115 5.97982C4.55252 9.63719 4.55252 14.3633 6.90115 18.0207C7.0129 18.1951 6.96227 18.4268 6.7879 18.5389C6.72527 18.5791 6.65477 18.5982 6.58577 18.5982Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.53061 20.572C3.40723 20.572 3.28648 20.5113 3.21448 20.3999C-0.0618916 15.2973 -0.0618916 8.70291 3.21448 3.59991C3.32661 3.42591 3.55836 3.37491 3.73273 3.48703C3.90711 3.59878 3.95773 3.83091 3.84598 4.00528C0.727484 8.86191 0.727484 15.1379 3.84598 19.9945C3.95773 20.1689 3.90711 20.4007 3.73273 20.5128C3.67011 20.5529 3.59998 20.572 3.53061 20.572Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.5037 8.37367V15.6262L15.2737 17.7149V17.7187L13.0837 18.7987V5.20117L15.2737 6.28492L19.5037 8.37367Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.5045 8.38354H22.875V15.6162H19.5045V8.38354Z",
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.2737 6.28492V17.7187L13.0837 18.7987V5.20117L15.2737 6.28492Z",
    fill: "#3F3F3F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute_icon.b2c51bc7edb2998b19658c10b138195e.svg";
export { ForwardRef as ReactComponent };